import approvalBox from './index.vue';

let _i18n = null;

// 国际化问题
export function RewriteLocale(i18n) {
  _i18n = i18n;
}

export default {
  install(Vue, options) {
    Vue.prototype._i18n = _i18n;
    Vue.prototype.$approvalBox = function(opts) {
      // 继承approvalBox组件
      const ApprovalConstructor = Vue.extend(approvalBox);
      // 创建一个新元素
      const approvalWrap = document.createElement('div');
      approvalWrap.className = 'approval-box-wrap';
      // 实例化approvalBox组件，并将组件挂在到新创建的approval-box-wrap元素上
      const approvalInstace = new ApprovalConstructor({
        el: approvalWrap
      });
      // 或者使用 approvalInstace.$mount(approvalWrap)挂载
      document.body.appendChild(approvalInstace.$el);
      // 显示组件内容
      if (opts) {
        approvalInstace.type = opts.type;
        approvalInstace.callBack = opts.callBack;
        approvalInstace.valid = opts.valid;
        approvalInstace.approvePlaceholder = opts.approvePlaceholder;
        approvalInstace.rejectPlaceholder = opts.rejectPlaceholder;
        approvalInstace.title = opts.title;
      }
      approvalInstace.approvalVisiable = true;
    };
  }
};



// WEBPACK FOOTER //
// ./src/libs/approvalBox/index.js